import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, TextField, Button, Box } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm, SubmitHandler } from 'react-hook-form';
import { useCreatePhoneNumberMutation } from 'features/createParticipant/createParticipant';

type DrawerShopDotsPhonePropsType = {
  id_shop: string;
};

type FormDataType = {
  sales_point_id: number;
  phone: string;
};

export const DrawerShopDotsPhone = ({ id_shop }: DrawerShopDotsPhonePropsType) => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen, actionDrawer } = useAppSelector((state) => state.ui);
  const [addPhoneRequest] = useCreatePhoneNumberMutation();

  const onSubmit: SubmitHandler<FormDataType> = () => {
    const data = getValues();
    addPhoneRequest({
      id: parseInt(id_shop),
      body: {
        phone: data.phone,
      },
    }).then(() => {
      dispatch(setDrawerOpen(false));
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  };

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      sales_point_id: 0,
      phone: '',
    },
  });

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent style={{ width: '800px' }}>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            {actionDrawer === 'createPhone' ? 'Создание номера для тороговй точки' : 'Изменение торговой точки'}
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <div style={{ marginBottom: '20px' }}>Сохдание номера для торговой точки</div>
            <Controller
              name="phone"
              control={control}
              render={({ field }) => (
                <TextField
                  type="text"
                  label="Номер телефона"
                  placeholder=""
                  fullWidth
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    marginBottom: '24px',
                  }}
                  error={formErrors.phone && true}
                  {...field}
                />
              )}
            />
          </div>
          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              sx={{ textTransform: 'none' }}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
